import { render, staticRenderFns } from "./ReminderDate.vue?vue&type=template&id=356081a8&"
import script from "./ReminderDate.vue?vue&type=script&lang=js&"
export * from "./ReminderDate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/atlassian/pipelines/agent/build/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('356081a8')) {
      api.createRecord('356081a8', component.options)
    } else {
      api.reload('356081a8', component.options)
    }
    module.hot.accept("./ReminderDate.vue?vue&type=template&id=356081a8&", function () {
      api.rerender('356081a8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/luckydraw/components/ReminderDate.vue"
export default component.exports